import { FileType } from '../../../../shared/fileUpload';
import { validArchiveUploadExtensions, validCodeSentryArchiveUploadExtensions, validSBOMUploadExtensions } from '../../../utils';

/**
 * Get the valid file extensions for the given fileType
 */
export const getValidFileExtensions = (fileType: FileType) => {
  if (fileType === FileType.SBOM) {
    return validSBOMUploadExtensions;
  }
  if (fileType === FileType.Binary) {
    return validCodeSentryArchiveUploadExtensions;
  }
  return validArchiveUploadExtensions;
};
